export const ajusteDiferencialRedondeo = (valor, decimales) => {
    if (decimales?.length === 0) return [];
    decimales.forEach((dec, index) => {
        decimales[index] = redondear(dec);
    });
    let ultimoIndex = decimales.length - 1;
    const diferencia = redondear(valor - redondear(decimales.reduce((acc, dec) => acc + dec, 0), 2), 2);
    decimales[ultimoIndex] = redondear(decimales[ultimoIndex] + diferencia, 2);
    return decimales;
};

export const ajusteDiferencialRedondeoJson = (valor, decimales, field) => {
    // COMPROBAMOS QUE EL CAMPO EXISTA
    if (!field) return [];
    // COMPORBAMOS QUE EXISTA UN ARRAY DE DECIMALES
    if (decimales?.length === 0) return [];
    decimales.forEach((dec, index) => {
        decimales[index][field] = redondear(dec[field]);
    });
    let ultimoIndex = decimales.length - 1;
    const diferencia = redondear(valor - redondear(decimales.reduce((acc, dec) => acc + dec[field], 0), 2), 2);
    decimales[ultimoIndex][field] = redondear(decimales[ultimoIndex][field] + diferencia, 2);
    return decimales;
};

// FUNCUON QUE REDONDEA UN NUMERO A UNA CANTIDAD DE DECIMALES DETERMINADA
export const redondear = (numero, decimales = 2) => {
    return parseFloat(numero.toFixed(decimales));
}